import type { IFilter } from "../models/Filter";
import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const updateInfo = async (data: Record<string, JSONValue>) => {
  return httpRequest.put("/prt/partner", data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/partner", { offset, filter });
};

export const updateAdmin = async (data: Record<string, JSONValue>) => {
  return httpRequest.put("/prt/partner/update_admin", data);
};

export const roleSelect = async (data: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/role/select", data);
};

export const uploadLogo = async (id: string, data: Record<string, JSONValue>) => {
  return httpRequest.put(`/prt/partner/${id}/logo`, data);
};

export const uploadLogoProfile = async (data: Record<string, JSONValue>) => httpRequest.put(`/prt/partner/logo`, data);
